var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dropdown',{staticClass:"click-tooltip",attrs:{"placement":_vm.placement},scopedSlots:_vm._u([{key:"popper",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)},[_vm._t("target")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }